import React, { useState, VFC } from 'react';
import dynamic from 'next/dynamic';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';

interface IMoreImages {
  images: Array<string>;
}

export const MoreImages: VFC<IMoreImages> = ({ images }) => {
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);

  const LightBox = dynamic(import('components/LightBox'), {
    ssr: false,
    loading: () => null, // TODO add loader if jumpy loadtime
  });

  return (
    <>
      <LightBox
        images={images}
        startIndex={0}
        isOpen={isLightBoxOpen}
        handleCloseBtn={() => setIsLightBoxOpen(false)}
      />
      <Button
        type={ButtonType.Button}
        variant={ButtonVariant.GhostInverted}
        size={ButtonSize.Small}
        onClick={() => setIsLightBoxOpen(true)}
      >
        {images.length <= 1 ? 'Se bild' : `Se alla ${images.length} bilder`}
      </Button>
    </>
  );
};
